import { render, staticRenderFns } from "./RgDetailPanel.vue?vue&type=template&id=b31f4930&scoped=true"
import script from "./RgDetailPanel.vue?vue&type=script&lang=js"
export * from "./RgDetailPanel.vue?vue&type=script&lang=js"
import style0 from "./RgDetailPanel.vue?vue&type=style&index=0&id=b31f4930&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31f4930",
  null
  
)

export default component.exports